import React from "react";
import { createUseStyles } from "react-jss";
import { xsmallDevice } from "../responsiveRules";
import Lightbulb from "../icons/lightbulb";
import Route from "../icons/route";
import Papers from "../icons/papers";

const useStyles = createUseStyles({
  card: {
    margin: "1em",
    padding: "3em",
    backgroundColor: "#fff",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    [xsmallDevice]: {
      margin: "1em 0",
    },
    "&:hover": {
      boxShadow: "5px 5px 5px #f5f5f5",
    },
  },
  title: {
    fontSize: "1.4em",
    color: "#000",
  },
  content: {
    marginTop: "1em",
    color: "#A3A3A3",
  },
  description: {
    fontSize: "1.2em",
    lineHeight: "1.6em",
  },
});

export const Card = ({ title, children, type = "code", inline }) => {
  const classes = useStyles();

  return (
    <div className={classes.card}>
      <div
        style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      >
        {type === "phone" && <Phone />}
        {type === "paper" && <Paper />}
        {type === "code" && <Code />}
        {type === "rocket" && <Rocket />}
        {type === "team" && <Team />}
        {type === "chat" && <Chat />}
        {type === "lightbulb" && <Lightbulb />}
        {type === "route" && <Route />}
        {type === "papers" && <Papers />}
        {inline && (
          <strong
            className={classes.title}
            style={{ marginLeft: 20, fontSize: 25 }}
          >
            {title}
          </strong>
        )}
      </div>
      <div className={classes.content}>
        {!inline && <strong className={classes.title}>{title}</strong>}
        <p className={classes.description}>{children}</p>
      </div>
    </div>
  );
};

const Phone = () => (
  <svg
    width="86"
    height="86"
    viewBox="0 0 86 86"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="43" cy="43" r="43" fill="#FFD75A" fillOpacity="0.4" />
    <path
      d="M37.6045 31.5801H31.8623C31.0695 31.5801 30.4268 32.2228 30.4268 33.0156V38.7578C30.4268 39.5506 31.0695 40.1934 31.8623 40.1934H37.6045C38.3973 40.1934 39.04 39.5506 39.04 38.7578V33.0156C39.04 32.2228 38.3973 31.5801 37.6045 31.5801ZM36.1689 37.3223H33.2979V34.4512H36.1689V37.3223Z"
      fill="#FFCE37"
    />
    <path
      d="M59.895 47.9275C59.1292 46.7311 57.7894 45.9357 56.2666 45.9355V24.3066C56.2666 21.932 54.3346 20 51.96 20H28.9912C26.6165 20 24.6846 21.932 24.6846 24.3066V61.7266C24.6846 64.1012 26.6165 66.0332 28.9912 66.0332C39.767 66.0332 39.0748 66.0406 39.2383 66.0179L40.6964 68.3302C40.9594 68.7471 41.4178 69 41.9107 69H62.0088C62.4939 69 62.9462 68.755 63.2112 68.3486L66.0823 63.9463C66.2344 63.7131 66.3154 63.4406 66.3154 63.1621V51.6779C66.3154 48.3878 62.7531 46.3105 59.895 47.9275ZM47.6533 36.9872C46.8909 36.3036 45.8844 35.8868 44.7822 35.8867V34.4512H47.6533V36.9872ZM49.0884 40.1934C49.8835 40.1934 50.5244 39.5491 50.5244 38.7578V33.0156C50.5244 32.2228 49.8817 31.5801 49.0889 31.5801H43.3467C42.5539 31.5801 41.9111 32.2228 41.9111 33.0156V36.9864C41.0305 37.7755 40.4751 38.9206 40.4751 40.1934V51.7558L40.131 51.2068C38.8812 49.2124 36.2705 48.582 34.2479 49.7876C32.1562 51.0345 31.5048 53.7537 32.8033 55.813L33.8167 57.4199H27.5557V28.709H53.3955V45.6005C52.2161 44.5431 50.567 44.2225 49.0884 44.7469C49.0884 44.3234 49.0884 40.6179 49.0884 40.1934ZM28.9912 22.8711H51.96C52.7515 22.8711 53.3955 23.5151 53.3955 24.3066V25.8379H27.5557V24.3066C27.5557 23.5151 28.1997 22.8711 28.9912 22.8711ZM28.9912 63.1621C28.1997 63.1621 27.5557 62.5181 27.5557 61.7266V60.291H35.6271L37.4375 63.1621H28.9912ZM63.4443 62.7354L61.2312 66.1289H42.7026L35.232 54.2816C34.7948 53.5885 35.0144 52.6733 35.7181 52.2538C36.3926 51.8515 37.2811 52.0658 37.6982 52.7314L40.6942 57.5124C41.0342 58.0547 41.6925 58.3067 42.3072 58.1298C42.9224 57.9529 43.3461 57.3902 43.3461 56.7501V40.1934C43.3461 39.4018 43.9901 38.7578 44.7817 38.7578C45.5732 38.7578 46.2172 39.4018 46.2172 40.1934V56.0801C46.2172 56.8729 46.8599 57.5156 47.6527 57.5156C48.4455 57.5156 49.0883 56.8729 49.0883 56.0801V48.8066C49.0883 48.0151 49.7323 47.3711 50.5238 47.3711C51.3154 47.3711 51.9594 48.0151 51.9594 48.8066V50.2422V56.0801C51.9594 56.8729 52.6021 57.5156 53.3949 57.5156C54.1877 57.5156 54.8305 56.8729 54.8305 56.0801V50.2422C54.8305 49.4506 55.4745 48.8066 56.266 48.8066C57.0576 48.8066 57.7016 49.4506 57.7016 50.2422V51.6779V56.0801C57.7016 56.8729 58.3443 57.5156 59.1371 57.5156C59.9299 57.5156 60.5727 56.8729 60.5727 56.0801V51.6779C60.5727 50.8863 61.2167 50.2422 62.0084 50.2422C62.8002 50.2422 63.4442 50.8863 63.4442 51.6779V62.7354H63.4443Z"
      fill="#FFCE37"
    />
  </svg>
);

const Code = () => (
  <svg
    width="86"
    height="86"
    viewBox="0 0 86 86"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="43" cy="43" r="43" fill="#F24444" fillOpacity="0.35" />
    <path
      d="M60 27V55.7286H48.7664V57.7828H50.8196V59.8336H34.1805V57.7828H36.2337V55.7286H25V27H60ZM38.2846 57.7828H46.7154V55.7286H38.2846V57.7828H38.2846ZM27.0508 53.6778H57.9492V49.5711H27.0509V53.6778H27.0508ZM27.0508 47.5203H57.9492V29.0509H27.0509V47.5203H27.0508Z"
      fill="#ED4242"
    />
    <path
      d="M46.0589 34.5788L47.509 33.1287L52.666 38.2856L47.509 43.4425L46.0589 41.9923L49.7657 38.2856L46.0589 34.5788Z"
      fill="#ED4242"
    />
    <path
      d="M37.4912 33.1287L38.9414 34.5788L35.2346 38.2856L38.9414 41.9923L37.4912 43.4425L32.3343 38.2856L37.4912 33.1287Z"
      fill="#ED4242"
    />
    <path
      d="M42.3155 32.1017L44.6963 44.0703L42.6847 44.4704L40.304 32.5018L42.3155 32.1017Z"
      fill="#ED4242"
    />
  </svg>
);

const Rocket = () => (
  <svg
    width="86"
    height="86"
    viewBox="0 0 86 86"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="43" cy="43" r="43" fill="#1DA2EE" fillOpacity="0.35" />
    <path
      d="M63.246 50.242L54.51 43.4971C52.1629 41.6851 50.7617 38.833 50.7617 35.8677V31.641C50.7617 29.0291 50.0266 26.4868 48.636 24.289C47.2839 22.152 45.374 20.4284 43.1128 19.3046L42.5 19L41.8871 19.3046C39.626 20.4284 37.7161 22.152 36.3639 24.289C34.9734 26.4868 34.2383 29.0291 34.2383 31.641V35.8677C34.2383 38.833 32.837 41.6851 30.4899 43.4971L21.7539 50.242V60.4922H31.4844V66H53.5156V60.4922H63.246V50.242ZM42.5 22.0991C45.5154 23.8368 47.4993 26.8444 47.9221 30.2641H37.0779C37.5006 26.8443 39.4845 23.8367 42.5 22.0991ZM36.9922 33.018H48.0078V57.7383H36.9922V33.018ZM45.2539 60.4922V63.2461H39.7461V60.4922H45.2539ZM24.5078 51.5949L32.1728 45.6769C32.9442 45.0814 33.6355 44.398 34.2383 43.6477V57.7383H24.5078V51.5949ZM34.2383 60.4922H36.9922V63.2461H34.2383V60.4922ZM50.7617 63.2461H48.0078V60.4922H50.7617V63.2461ZM60.4921 57.7383H50.7617V43.6477C51.3643 44.398 52.0556 45.0814 52.827 45.6769L60.4921 51.5949V57.7383Z"
      fill="#2FB0FA"
    />
  </svg>
);

const Paper = () => (
  <svg
    width="86"
    height="86"
    viewBox="0 0 86 86"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="43" cy="43" r="43" fill="#FFEFBD" />
    <path
      d="M61.9999 42.4976C61.9991 42.102 61.7936 41.735 61.4569 41.5274L57.4934 39.0841L61.4611 36.6145C61.7957 36.4063 61.9993 36.0403 61.9999 35.6462C62.0005 35.2521 61.798 34.8855 61.464 34.6763L43.1066 23.1744C42.7356 22.9419 42.2643 22.9419 41.8933 23.1744L23.5359 34.6763C23.202 34.8855 22.9995 35.2521 23 35.6462C23.0006 36.0403 23.2042 36.4064 23.5388 36.6145L27.4793 39.0671L23.5371 41.5312C23.2027 41.7402 22.9997 42.1068 23.0001 42.5011C23.0005 42.8955 23.2041 43.2617 23.5389 43.4701L27.4794 45.9227L23.5371 48.3866C23.2032 48.5953 23.0003 48.9612 23.0001 49.3549C22.9998 49.7486 23.2024 50.1147 23.536 50.3237L41.8934 61.8256C42.0789 61.9419 42.2895 62 42.5 62C42.7105 62 42.9212 61.9419 43.1066 61.8256L61.464 50.3237C61.7987 50.114 62.0014 49.7463 61.9999 49.3513C61.9985 48.9564 61.7931 48.5901 61.4569 48.3829L57.4934 45.9396L61.4611 43.47C61.7969 43.261 62.0008 42.8931 61.9999 42.4976ZM26.2998 35.6414L42.5 25.491L58.7002 35.6414C58.5445 35.7383 42.9643 45.4356 42.5 45.7246L26.2998 35.6414ZM58.6928 49.3634L42.5 59.5091L26.2966 49.3567L29.6396 47.2673L41.8963 54.8959C42.0811 55.0109 42.2905 55.0684 42.5 55.0684C42.7095 55.0684 42.9189 55.0109 43.1037 54.8959L55.3265 47.2883L58.6928 49.3634ZM42.5 52.58L26.3017 42.4981L29.6396 40.4118L41.8963 48.0404C42.0811 48.1554 42.2905 48.2129 42.5 48.2129C42.7095 48.2129 42.9189 48.1554 43.1037 48.0404L55.3265 40.4329L58.6876 42.5047C58.5947 42.5625 42.9288 52.313 42.5 52.58Z"
      fill="#FFCE37"
    />
  </svg>
);

const Team = () => (
  <svg
    width="86"
    height="86"
    viewBox="0 0 86 86"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="43" cy="43" r="43" fill="#FABEBE" />
    <path
      d="M57.8477 43.9969H53.7364C53.1769 43.9969 52.6351 44.0733 52.1196 44.2139C51.1026 42.2146 49.0262 40.8409 46.6336 40.8409H39.3664C36.9738 40.8409 34.8974 42.2146 33.8804 44.2139C33.3649 44.0733 32.8231 43.9969 32.2636 43.9969H28.1523C24.7599 43.9969 22 46.7568 22 50.1492V56.7214C22 58.7568 23.656 60.4128 25.6914 60.4128H60.3086C62.344 60.4128 64 58.7568 64 56.7214V50.1492C64 46.7568 61.2401 43.9969 57.8477 43.9969ZM33.2141 46.9935V57.9519H25.6914C25.0129 57.9519 24.4609 57.3999 24.4609 56.7215V50.1493C24.4609 48.1138 26.1169 46.4579 28.1523 46.4579H32.2636C32.5976 46.4579 32.9211 46.5032 33.229 46.5868C33.2202 46.7214 33.2141 46.8568 33.2141 46.9935ZM50.325 57.9519H35.675V46.9934C35.675 44.9579 37.331 43.302 39.3664 43.302H46.6336C48.669 43.302 50.325 44.9579 50.325 46.9934V57.9519ZM61.5391 56.7215C61.5391 57.3999 60.9871 57.9519 60.3086 57.9519H52.7859V46.9934C52.7859 46.8566 52.7798 46.7213 52.771 46.5867C53.0789 46.5032 53.4024 46.4578 53.7364 46.4578H57.8477C59.8831 46.4578 61.5391 48.1138 61.5391 50.1492V56.7215Z"
      fill="#ED4242"
    />
    <path
      d="M30.2078 32.3772C27.1932 32.3772 24.7407 34.8297 24.7407 37.8443C24.7406 40.8588 27.1932 43.3113 30.2078 43.3113C33.2223 43.3113 35.6748 40.8588 35.6748 37.8443C35.6748 34.8297 33.2223 32.3772 30.2078 32.3772ZM30.2077 40.8504C28.5501 40.8504 27.2016 39.5019 27.2016 37.8443C27.2016 36.1866 28.5501 34.8381 30.2077 34.8381C31.8653 34.8381 33.2138 36.1866 33.2138 37.8443C33.2138 39.5019 31.8653 40.8504 30.2077 40.8504Z"
      fill="#ED4242"
    />
    <path
      d="M43.0002 25.5872C38.9728 25.5872 35.6963 28.8637 35.6963 32.8911C35.6963 36.9185 38.9728 40.195 43.0002 40.195C47.0276 40.195 50.3041 36.9185 50.3041 32.8911C50.3041 28.8637 47.0276 25.5872 43.0002 25.5872ZM43.0002 37.734C40.3297 37.734 38.1572 35.5615 38.1572 32.8911C38.1572 30.2207 40.3297 28.0481 43.0002 28.0481C45.6706 28.0481 47.8431 30.2206 47.8431 32.8911C47.8431 35.5615 45.6706 37.734 43.0002 37.734Z"
      fill="#ED4242"
    />
    <path
      d="M55.7918 32.3772C52.7773 32.3772 50.3247 34.8297 50.3247 37.8443C50.3248 40.8588 52.7773 43.3113 55.7918 43.3113C58.8063 43.3113 61.2588 40.8588 61.2588 37.8443C61.2588 34.8297 58.8063 32.3772 55.7918 32.3772ZM55.7918 40.8504C54.1342 40.8504 52.7856 39.5019 52.7856 37.8443C52.7857 36.1866 54.1342 34.8381 55.7918 34.8381C57.4494 34.8381 58.7979 36.1866 58.7979 37.8443C58.7979 39.5019 57.4494 40.8504 55.7918 40.8504Z"
      fill="#ED4242"
    />
  </svg>
);

const Chat = () => (
  <svg
    width="86"
    height="86"
    viewBox="0 0 86 86"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="43" cy="43" r="43" fill="#1DA2EE" fill-opacity="0.35" />
    <path
      d="M55.5 26.25H29.5C27.7125 26.25 26.25 27.7125 26.25 29.5V58.75L32.75 52.25H55.5C57.2875 52.25 58.75 50.7875 58.75 49V29.5C58.75 27.7125 57.2875 26.25 55.5 26.25ZM55.5 49H32.75L29.5 52.25V29.5H55.5V49Z"
      fill="#2FB0FA"
    />
  </svg>
);
